/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import Logger from "../lib/logger";
import initHeader from "./header";

export default function () {
	const NAME = "Global";
	Logger.info(`${NAME} > loading`);

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * init --- Initialization block
	 */
	function init() {
		Logger.info(`${NAME} > init`);
		initHeader();
	}

	// Do not edit below this line...
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	Logger.info(`${NAME} > loaded`);

	init();
}
